import { Identity, Customer } from './customer.model';
import { Channel } from './channel.model';
export interface PreRegistration extends Identity, Customer, Channel {
    ref_channel_no:number;
}

export interface ClonePreRegistration extends Identity, Customer, Channel {
    lead_reference_number:number;
}

export interface ClonePreRegistrationUcid extends Channel {
    ucid_lead:string
}

export enum ResponseCodePreRegistration{
    SUCCESS = 'S20000',
    NOT_CREATE = 'E40001'
}

